/**
 * POST /v1/user/list — payload shape matches platform API (camelCase fields).
 *
 * @param {string} tenantUuid — workspace / tenant UUID for the list scope
 * @param {number} page
 * @param {number} pageSize
 * @param {string} [searchKeyword] — when non-empty, adds `search: { keyword }` for server-side search
 */
export const buildTenantUserListBody = (tenantUuid, page, pageSize, searchKeyword = '') => {
  const body = {
    tenantUuid,
    page,
    page_size: pageSize,
    order_by: 'createdAt',
    order_direction: 'DESC',
  };
  const kw = typeof searchKeyword === 'string' ? searchKeyword.trim() : '';
  if (kw) {
    body.search = { keyword: kw };
  }
  return body;
};
